var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.$store.getters['resource/currentResource'].key},[_c('help',{attrs:{"text":_vm.$t('help.group_create'),"title":_vm.$t('help.group_create_title')}}),_c('div',[_c('GroupSubscriptionsView',{attrs:{"fields":_vm.fields}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }